export const urls = {
  loginUrl: '/api',
  backendUrl: '/api/v1',
  backendUrlV2: '/api/v2',
  embedBackendUrl: '/embed',
  statisticsBackendUrl: '/api/v2/statistics/prod',
  koodistoUrl: '/ref/api/v1',
  frontendUrl: location.origin
}
